import React from "react";
import { Modal } from "react-bootstrap";
import Button from "../../uiComponent/button/index";

import RemoveIcon from "../../../assets/icons/new-modal-delete-icon.svg"

import { ModalWrapper } from "./style";
import "../../../assets/modal.css"

const Index = (props) => {
  const { open, onHide, onClose, onSave, header, heading, className, closeText, saveText, size, closeButton, centerAlign, removeIcon, buttonDisabled } = props;
  return (
    <ModalWrapper size={size} show={open} onHide={onHide} className={className} centered={true}>
      {header && (
        <Modal.Header closeButton={closeButton} className={heading ? "" : "header-padding"}>
          <Modal.Title className="fw-bold">{heading}</Modal.Title>
        </Modal.Header>
      )}
    {removeIcon && <img onClick={onClose} src={RemoveIcon} className="close-modal-icon-custom" />}
      <Modal.Body className="p-4" >{props.children}</Modal.Body>
      {saveText &&
        <Modal.Footer className={`gap-2 ${centerAlign && "justify-content-center"}`}>
          <Button className="outlined" onClick={onClose} text={closeText} />
          <Button className="primary" disabled={buttonDisabled} onClick={onSave} text={saveText} />
        </Modal.Footer>
      }
    </ModalWrapper>
  );
};
export default Index;
